<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
    <Toast />
    <div class="col-12 sticky">
      <div id="custom_card" class="card">
        <div class="grid justify-content-between">
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
            >
              <p style="color: #09517a; font-size: 20px; font-weight: 800">
                {{ $t("assets") }}
              </p>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3"
            >
              <Button
                iconPos="right"
                :label="$t('add')"
                v-tooltip.bottom="$t('add')"
                icon="pi pi-plus"
                @click="openNew"
                size="small"
                style=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card" id="custom_card">
        <div class="grid p-fluid">
          <div class="col-12 md:col-12">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText
                    format="text"
                    v-model="search_filter"
                    @input="search(1)"
                  >
                  </InputText>
                  <label>{{ $t("search_time") }}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown
                    id="status"
                    v-model="status_dropdownItem"
                    :options="asset_status_master"
                    optionLabel="name"
                    filter
                    @change="search(1)"
                  >
                  </Dropdown>
                  <label for="status">{{ $t("asset_status") }}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown
                    id="type"
                    v-model="type_dropdownItem"
                    :options="asset_type_master"
                    optionLabel="name"
                    filter
                    @change="search(1)"
                  >
                  </Dropdown>
                  <label for="type">{{ $t("asset_type") }}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown
                    id="subtype"
                    v-model="subtype_dropdownItem"
                    :options="asset_subtype_master"
                    optionLabel="name"
                    filter
                    @change="search(1)"
                  >
                  </Dropdown>
                  <label for="subtype">{{ $t("asset_subtype") }}</label>
                </span>
              </div>
              <div class="field col-2 md:col-2">
                <Button
                  icon="pi pi-refresh"
                  v-tooltip.bottom="$t('refresh')"
                  @click="search(2)"
                  class="p-button-danger"
                  style=""
                />
              </div>
            </div>
          </div>
        </div>
        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="PerPageOptions"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">{{ $t("no_rec") }}</b>
          </template>
          <template #header>
            <div style="text-align: right; font-weight: bold">
              <span>{{ $t("total_assets") }}:</span>{{ totalRecords }}
            </div>
          </template>
          <Column :header="$t('asset_code')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.asset_code }}
            </template>
          </Column>
          <Column :header="$t('asset_discription')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.asset_discription }}
            </template>
          </Column>
          <Column :header="$t('expected_life_years')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.expected_life_years }}
            </template>
          </Column>
          <Column :header="$t('purchase_date')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ dateFormatDMY(data.purchase_date) }}
            </template>
          </Column>
          <Column :header="$t('purchase_price')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.purchase_price }}
            </template>
          </Column>
          <Column :header="$t('current_depreciated_value')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.current_depreciated_value }}
            </template>
          </Column>
          <Column :header="$t('asset_status_name')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.asset_status_name }}
            </template>
          </Column>
          <Column :header="$t('asset_type_name')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.asset_type_name }}
            </template>
          </Column>
          <Column :header="$t('asset_subtype_name')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.asset_subtype_name }}
            </template>
          </Column>
          <Column :header="$t('expiry_date')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ dateFormatDMY(data.expiry_date) }}
            </template>
          </Column>
          <Column :header="$t('edit')" headerStyle="min-width:5rem;">
            <template #body="slotProps">
              <Button
                v-if="slotProps.data.asset_status_name == 'Active'"
                icon="pi pi-pencil"
                :title="$t('edit_client')"
                v-tooltip.bottom="$t('edit')"
                class="p-button-rounded p-button-success mr-2"
                @click="editProduct(slotProps.data)"
                style=""
              />
              <!-- <Button
                v-if="slotProps.data.status != 'Deleted'"
                icon="pi pi-trash"
                v-tooltip.bottom="$t('delete')"
                class="p-button-rounded p-button-danger mt-2"
                @click="confirmDeleteProduct(slotProps.data)"
                style=""
              /> -->
            </template>
          </Column>
          <Column :header="$t('transaction')" headerStyle="min-width:10rem;">
            <template #body="slotProps">
                <Button
                
                icon="pi pi-eye"
                :title="$t('view_details')"
                v-tooltip.bottom="$t('view')"
                class="p-button-rounded p-button-warning mr-2"
                @click="viewProduct(slotProps.data)"
                style=""
              />
              <Button
                v-if="slotProps.data.asset_status_name == 'Active'"
                icon="pi pi-plus"
                :title="$t('edit_client')"
                v-tooltip.bottom="$t('add')"
                class="p-button-rounded p-button-primary mr-2"
                @click="addTransaction(slotProps.data)"
                style=""
              />
              
            </template>
          </Column>
          <Column :header="$t('depreciation')" headerStyle="min-width:5rem;">
            <template #body="slotProps">
              <Button
                icon="pi pi-file"
                :title="$t('view_depreciation')"
                v-tooltip.bottom="$t('depreciationview')"
                class="p-button-rounded p-button-primary mr-2"
                @click="view_depreciation(slotProps.data)"
              />

            </template>
            
          </Column>
        </DataTable>
      </div>
    </div>
    <Dialog
      v-model:visible="viewDialog"
      :breakpoints="{ '960px': '75vw' }"
      :style="{ width: '75vw' }"
      :header="$t('Transaction')"
      :modal="true"
      position="top"
    >
    <div class="col-12">
    <DataTable
          :loading="viewloading"
          ref="dt"
          :lazy="true"
          :totalRecords="viewtotalRecords"
          :paginator="true"
          :value="viewproducts"
          :rows="viewlimit"
          :filters="viewfilters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="viewPerPageOptions"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
        <template #empty>
            <b style="text-align: center">{{ $t("no_rec") }}</b>
          </template>
          <template #header>
            <div style="text-align: right; font-weight: bold">
              <span>{{ $t("total_transaction") }}:</span>{{ viewtotalRecords }}
            </div>
          </template>
          <Column :header="$t('asset_code')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.asset_code }}
            </template>
          </Column>
          <Column :header="$t('asset_discription')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.asset_discription }}
            </template>
          </Column>
           <Column :header="$t('asset_transaction_date')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ dateFormatDMY(data.asset_transaction_date) }}
            </template>
          </Column>
          <Column :header="$t('asset_transaction_type_name')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.asset_transaction_type_name }}
            </template>
          </Column>
          <Column :header="$t('write_off_reason')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.write_off_reason }}
            </template>
          </Column>
          <Column :header="$t('asset_transaction_amount')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.asset_transaction_amount }}
            </template>
          </Column>
    </DataTable>
    </div>
    </Dialog>
    <Dialog
      v-model:visible="transactionDialog"
      :breakpoints="{ '960px': '75vw' }"
      :style="{ width: '75vw' }"
      :header="$t('Transaction')"
      :modal="true"
      position="top"
    >
    <div class="col-12">
        <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="ticket_title"
                type="text"
                v-model="product.asset_code"
                disabled
              />
              <label for="name">{{ $t("asset_code") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="asset_discription"
                type="text"
                v-model="product.asset_discription"
                disabled
              />
              <label for="name">{{ $t("asset_discription") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
             <Calendar
                id="ticket_title"
                v-model="product.asset_transaction_date"
                dateFormat="dd/mm/yy"
                
              />
              <label for="name">{{ $t("asset_transaction_date") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="asset_transaction_amount"
                type="number"
                v-model="product.asset_transaction_amount"
                
                rows="5"
              />
              <label for="name">{{ $t("asset_transaction_amount") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <Dropdown
                id="type"
                v-model="addedittransactiontype_dropdownItem"
                :options="asset_transaction_type_master"
                optionLabel="name"
                filter
                v-on:change="check_transaction_type()"
                :optionDisabled="isOptionDisabled"
              >
              </Dropdown>
              <label for="type">{{ $t("asset_transaction_type") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%" v-if="show">
            <span class="p-float-label">
              <Dropdown
                id="type"
                v-model="addeditwriteoffreason_dropdownItem"
                :options="asset_writeoff_reason_master"
                optionLabel="name"
                filter
              >
              </Dropdown>
              <label for="type">{{ $t("asset_writeoff_reason") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 2%">
            <span class="p-float-label">
              <Textarea
                id="transaction_remarks"
                type="text"
                rows="5"
                v-model="product.transaction_remarks"
              />
              <label for="name">{{ $t("transaction_remarks") }}</label>
            </span>
          </div>
        </div>
    </div>
    <template #footer>
        <Button
          :label="$t('save')"
          @click="save_trans"
          icon="pi pi-check"
          class="p-button-success"
        />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="productDialog"
      :breakpoints="{ '960px': '75vw' }"
      :style="{ width: '75vw' }"
      :header="$t('assets')"
      :modal="true"
      position="top"
    >
      <div class="col-12">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="ticket_title"
                type="text"
                v-model="product.asset_code"
              />
              <label for="name">{{ $t("asset_code") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="asset_discription"
                type="text"
                v-model="product.asset_discription"
              />
              <label for="name">{{ $t("asset_discription") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                rows="6"
                id="expected_life_years"
                type="number"
                v-model="product.expected_life_years"
              />
              <label for="name">{{ $t("expected_life_years") }}</label>
            </span>
          </div>
           <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
             <Calendar
                id="ticket_title"
                v-model="product.purchase_date"
                dateFormat="dd/mm/yy"
                :disabled="product._id"
              />
              <label for="name">{{ $t("purchase_date") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="purchase_price"
                type="number"
                v-model="product.purchase_price"
                :disabled="product._id"
                rows="5"
              />
              <label for="name">{{ $t("purchase_price") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <Dropdown
                id="status"
                v-model="addeditstatus_dropdownItem"
                :options="asset_status_master"
                optionLabel="name"
                filter
                disabled
              >
              </Dropdown>
              <label for="status">{{ $t("asset_status") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <Dropdown
                id="type"
                v-model="addedittype_dropdownItem"
                :options="asset_type_master"
                optionLabel="name"
                filter
                v-on:change="get_assets_subtype_type_details()"
              >
              </Dropdown>
              <label for="type">{{ $t("asset_type") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <Dropdown
                id="subtype"
                v-model="addeditsubtype_dropdownItem"
                :options="asset_subtype_master"
                optionLabel="name"
                filter
              >
              </Dropdown>
              <label for="subtype">{{ $t("asset_subtype") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <Dropdown
                id="depreciation_method"
                v-model="addeditdepreciation_dropdownItem"
                :options="asset_depreciation_method_master"
                optionLabel="name"
                filter
                :disable="product._id"
              >
              </Dropdown>
              <label for="depreciation_method">{{ $t("asset_depreciation_method") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="current_location"
                type="text"
                v-model="product.current_location"
              />
              <label for="name">{{ $t("current_location") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="current_user"
                type="text"
                v-model="product.current_user"
              />
              <label for="name">{{ $t("current_user") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-4" style="margin-top: 2%">
            <span class="p-float-label">
              <Calendar
                id="ticket_title"
                v-model="product.expiry_date"
                dateFormat="dd/mm/yy"
              />
              <label for="name">{{ $t("expiry_date") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-12" style="margin-top: 2%">
            <span class="p-float-label">
              <Textarea
                id="transaction_remarks"
                type="text"
                rows="5"
                v-model="product.transaction_remarks"
              />
              <label for="name">{{ $t("transaction_remarks") }}</label>
            </span>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('save')"
          @click="save_event"
          icon="pi pi-check"
          class="p-button-success"
        />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="deleteProductDialog"
      :style="{ width: '450px' }"
      :header="$t('Confirm')"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="product"
          >{{ $t("delete_msg") }}<b>{{ product.day_of_week }}</b
          >?</span
        >
      </div>
      <template #footer>
        <Button
          :label="$t('no')"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteProductDialog = false"
        />
        <Button
          :label="$t('yes')"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteevent"
        />
      </template>
    </Dialog>
  </div>
</template>
  <script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
export default {
  data() {
    return {
        viewDialog:false,
        show:false,
      asset_status_master: [],
      status_dropdownItem: null,
      addeditstatus_dropdownItem: null,

      asset_type_master: [],
      type_dropdownItem: null,
      addedittype_dropdownItem: null,

      asset_subtype_master: [],
      original_asset_subtype_master: [],
      subtype_dropdownItem: null,
      addeditsubtype_dropdownItem: null,

      asset_depreciation_method_master: [],
      depreciation_dropdownItem: null,
      addeditdepreciation_dropdownItem: null,

      asset_transaction_type_master: [],
      transaction_type_dropdownItem: null,
      addedittransactiontype_dropdownItem: null,

      asset_writeoff_reason_master: [],
      writeoff_reason_dropdownItem: null,
      addeditwriteoffreason_dropdownItem: null,


      search_filter: "",
      user_key: "",
      page_no: 1,
      isLoading: false,
      PerPageOptions: [10, 50, 100],
      viewPerPageOptions: [10, 50, 100],
      isLoadingModel: false,
      loading: false,
      viewloading: false,
      fullPage: true,
      products: null,
      viewproducts: null,
      productDialog: false,
      transactionDialog:false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      viewfilters: {},
      offset: 1,
      limit: 10,
      viewlimit: 10,
      columns: [],
       viewcolumns: [],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      viewtotalRecords: 0,
      id: "",
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.user_key = localStorage.getItem("user_type");
    this.getAllMasters();
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.viewcolumns = [];
      this.totalRecords = 0;
      this.viewtotalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  watch: {
    currentLocale() {},
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    check_transaction_type()
    {   this.show=false;
        this.addeditwriteoffreason_dropdownItem=null;
        var temp = this.addedittransactiontype_dropdownItem?.name;
        if (temp=='Write-Off' ) 
        {   
            this.show=true;
        }    
    },
    isOptionDisabled(option) 
    {
        return option.name === 'Purchase'; // disable the "Purchase" row
    },
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "/" + month + "/" + year;
          }
        }
      } else {
        return "";
      }
    },
    async save_event() {
      if (!this.product.asset_code) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_asset_code"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.asset_discription) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_asset_discription"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.expected_life_years) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_expected_life_years"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.purchase_date) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_purchase_date"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.purchase_price) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_purchase_price"),
          life: 3000,
        });
        return false;
      }
      if (!this.addeditstatus_dropdownItem) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_status"),
          life: 3000,
        });
        return false;
      }
      if (!this.addedittype_dropdownItem) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_asset_type"),
          life: 3000,
        });
        return false;
      }
      if (!this.addeditsubtype_dropdownItem) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_asset_subtype"),
          life: 3000,
        });
        return false;
      }
      if (!this.addeditdepreciation_dropdownItem) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_depreciation"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.current_location) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_current_location"),
          life: 3000,
        });
        return false;
      }
       if (!this.product.current_user) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_current_user"),
          life: 3000,
        });
        return false;
      }
       if (!this.product.expiry_date) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_expiry_date"),
          life: 3000,
        });
        return false;
      }
       if (!this.product.transaction_remarks) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_transaction_remarks"),
          life: 3000,
        });
        return false;
      }
      var details = {};
      if (this.product._id) {
        details = {
            _id: this.product._id,
            "asset_discription": this.product.asset_discription,
            "expected_life_years": this.product.expected_life_years,
            "purchase_date": this.product.purchase_date,
            "purchase_price": this.product.purchase_price,
            "asset_status": this.addeditstatus_dropdownItem?.value,
            "asset_type": this.addedittype_dropdownItem?.value,
            "asset_sub_type": this.addeditsubtype_dropdownItem?.value,
            "current_location": this.product.current_location,
            "current_user":  this.product.current_user,
            "expiry_date": this.product.expiry_date,
            "FilePath": "",
            "updated_by": localStorage.getItem("id"),
            "transaction_remarks": this.product.transaction_remarks,
            "lang": this.$i18n.locale,
        };
        var promise = apis.updateAsset(details);
      } else {
        details = {
            "asset_code": this.product.asset_code,
            "asset_discription": this.product.asset_discription,
            "expected_life_years": this.product.expected_life_years,
            "purchase_date": this.product.purchase_date,
            "purchase_price": this.product.purchase_price,
            "asset_status": this.addeditstatus_dropdownItem?.value,
            "asset_type": this.addedittype_dropdownItem?.value,
            "asset_sub_type": this.addeditsubtype_dropdownItem?.value,
            "depreciation_method": this.addeditdepreciation_dropdownItem?.value,
            "current_location": this.product.current_location,
            "current_user":  this.product.current_user,
            "expiry_date": this.product.expiry_date,
            "FilePath": "",
            "transaction_remarks": this.product.transaction_remarks,
            "created_by": localStorage.getItem("id"),
            "client_id": localStorage.getItem("client_id"),     
            "lang": this.$i18n.locale,
        };
        var promise = apis.createAsset(details);
      }
      this.isLoadingModel = true;
      promise.then((response) => {
        this.isLoadingModel = false;
        if (response.data.status == true) {
          this.$toast.add({
            severity: "success",
            summary: "success",
            detail: response.data.message,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: response.data.message,
            life: 3000,
          });
        }
        this.productDialog = false;
        this.get_list();
        this.get_count();
      });
    },
    save_trans()
    {
        if (!this.product.asset_transaction_date) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_transaction_date"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.asset_transaction_amount) 
      {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_transaction_amount"),
          life: 3000,
        });
        return false;
      }
      if (!this.addedittransactiontype_dropdownItem) 
      {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_transactiontype"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.transaction_remarks) 
      {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_transaction_remarks"),
          life: 3000,
        });
        return false;
      }

       var  details = {
            
            "asset_id":this.product._id,
            "transaction_type":this.addedittransactiontype_dropdownItem?.value,
            "asset_transaction_date":this.product.asset_transaction_date,
            "asset_transaction_amount":this.product.asset_transaction_amount,
            "write_off_reason":this.addeditwriteoffreason_dropdownItem?.value,
            "transaction_remarks":this.product.transaction_remarks,
            "created_by":localStorage.getItem("id"),
            "client_id":localStorage.getItem("client_id"), 
            "lang": this.$i18n.locale,
        };
        var promise = apis.insertTransaction(details);
        this.isLoadingModel = true;
      promise.then((response) => {
        this.isLoadingModel = false;
        if (response.data.status == true) {
          this.$toast.add({
            severity: "success",
            summary: "success",
            detail: response.data.message,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: response.data.message,
            life: 3000,
          });
        }
        this.transactionDialog = false;
        this.get_list();
        this.get_count();
      });

    },
    convertToTime12Hour(isoString) {
      const date = new Date(isoString);
      let hours = date.getHours();
      let minutes = date.getMinutes();
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // Convert 0 to 12
      minutes = minutes < 10 ? "0" + minutes : minutes;
      return `${hours}:${minutes} ${ampm}`;
    },
    async search(count) {
      if (count == 2) {
        this.search_filter = "";
        this.status_dropdownItem = null;
        this.type_dropdownItem = null;
        this.subtype_dropdownItem = null;
      }
      await this.get_list();
      await this.get_count();
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        asset_status: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: true,
        "asset_type":this.type_dropdownItem?.value,
        "asset_sub_type":this.subtype_dropdownItem?.value,
        "depreciation_method":""
      };
      this.loading = true;
      var promise = apis.listAssets(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        if (this.totalRecords > 100) {
          this.PerPageOptions.push(this.totalRecords);
        }
        //alert(this.totalRecords);
      });
      console.log(data);
    },
    getAllMasters: function () 
    {
      var data = {client_id: localStorage.getItem("client_id")};
      var promise = apis.getAllAssetMaster(data, this.id);
      promise.then((response) => {
        const temp = response.data.data.asset_status_master;
        this.asset_status_master = temp.map(item => ({
        name: item.asset_status,
        value: item._id
        }));

        const temp2 = response.data.data.asset_type_master;
        this.asset_type_master = temp2.map(item => ({
        name: item.asset_type,
        value: item._id
        }));

        const temp3 = response.data.data.asset_subtype_master;
        this.asset_subtype_master = temp3.map(item => ({
        name: item.asset_subtype,
        value: item._id
        }));

        const temp4 = response.data.data.asset_depreciation_method_master;
        this.asset_depreciation_method_master = temp4.map(item => ({
        name: item.depreciation_method,
        value: item._id
        }));

        this.original_asset_subtype_master = response.data.data.asset_subtype_master;
    
        const temp5 = response.data.data.asset_transaction_type_master;
        this.asset_transaction_type_master = temp5.map(item => ({
        name: item.asset_transaction_type,
        value: item._id
        }));

        const temp6 = response.data.data.asset_writeoff_reason_master;
        this.asset_writeoff_reason_master = temp6.map(item => ({
        name: item.asset_writoff_reason,
        value: item._id
        }));
    
    
      });
    },
    get_assets_subtype_type_details()
    {
        this.addeditsubtype_dropdownItem=null;
        const temp3 = this.original_asset_subtype_master.filter(
          (subtype) => subtype.asset_type_id === this.addedittype_dropdownItem.value
        );
        this.asset_subtype_master = temp3.map(item => ({
        name: item.asset_subtype,
        value: item._id
        }));   
    },
    get_list: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        asset_status: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: false,
        page_no: this.page_no,
        limit: this.limit,
        "asset_type":this.type_dropdownItem?.value,
        "asset_sub_type":this.subtype_dropdownItem?.value,
        "depreciation_method":""
      };
      this.loading = true;
      var promise = apis.listAssets(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      const activeStatus = this.asset_status_master.find(
        (status) => status.name === 'Active'
        );
        if (activeStatus) {
        this.addeditstatus_dropdownItem = {
            name: activeStatus.name,
            value: activeStatus.value
        };
        }
      this.addedittype_dropdownItem=null;
      this.addeditsubtype_dropdownItem=null;
      this.addeditdepreciation_dropdownItem=null
    },
    async addTransaction(product)
    {
        this.product = { ...product };
        this.transactionDialog = true;
    },
     async view_depreciation(product)
     {
      this.product = { ...product };
      localStorage.setItem("product", JSON.stringify(this.product));
      this.$router.push({ name: "Depreciation_history_asset_wise"});
     },
    viewProduct(product)
    {   this.viewproducts=[];
        this.product = { ...product };
        var data = {
            "client_id":localStorage.getItem("client_id"),
            "count":false,
            "page_no":1,
            "limit":10,
            "asset_id":this.product._id
        };
        this.loading = true;
        var promise = apis.listTransaction(data, this.id);
        promise.then((response) => {
            this.loading = false;
            this.viewproducts = response.data.data;
            
        });

        var data = {
            "client_id":localStorage.getItem("client_id"),
            "count":true,
           
            "asset_id":this.product._id
        };
        this.loading = true;
        var promise = apis.listTransaction(data, this.id);
        promise.then((response) => {
            this.loading = false;
            this.viewtotalRecords = response.data.data;
            
        });



        // call api
        this.viewDialog = true;
    },
    async editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.addeditstatus_dropdownItem = null;
      if (this.product.asset_status) 
      {
        this.addeditstatus_dropdownItem = {
          name: this.product.asset_status_name,
          value: this.product.asset_status,
        };
      }
      this.addedittype_dropdownItem = null;
      if (this.product.asset_type) 
      {
        this.addedittype_dropdownItem = {
          name: this.product.asset_type_name,
          value: this.product.asset_type,
        };
      }
      this.addeditsubtype_dropdownItem = null;
      if (this.product.asset_sub_type) 
      {
        this.addeditsubtype_dropdownItem = {
          name: this.product.asset_subtype_name,
          value: this.product.asset_sub_type,
        };
      }
      this.addeditdepreciation_dropdownItem = null;
      if (this.product.depreciation_method) 
      {
        this.addeditdepreciation_dropdownItem = {
          name: this.product.depreciation_method_name,
          value: this.product.depreciation_method,
        };
      }
      if (this.product.expiry_date) {
        this.product.expiry_date = new Date(this.product.expiry_date);
      }
      if (this.product.purchase_date) {
        this.product.purchase_date = new Date(this.product.purchase_date);
      }
      this.productDialog = true;
    },
    convertToISOString(timeStr) {
      const [time, modifier] = timeStr.split(" ");
      let [hours, minutes] = time.split(":").map(Number);
      if (modifier.toUpperCase() === "PM" && hours !== 12) {
        hours += 12;
      }
      if (modifier.toUpperCase() === "AM" && hours === 12) {
        hours = 0;
      }
      const now = new Date();
      now.setHours(hours, minutes, 0, 0); // set HH:mm:00.000
      return new Date(now.toISOString());
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteevent() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          updated_by: localStorage.getItem("id"),
          lang: this.$i18n.locale,
        };
        this.isLoadingModel = true;
        var promise = apis.deleteTimeEntry(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            this.$toast.add({
              severity: "success", // success, info, warn, error
              summary: this.$t("success"),
              detail: responseapi.data.message,
              life: 3000, // Toast disappears after 3 seconds
            });
            this.deleteProductDialog = false;
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Video");
          }
        });
      }
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
  <style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
  